export default __webpack_public_path__ + "d2d2e17d51865981ffdc5d23ead71670.png";